import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

import type {
  ApiResponse,
  EventSettings,
  ExportOverviewReportResult,
  OverviewFocusNow,
  OverviewHealthRow,
  OverviewKpi,
  UpdateSwitchesPayload,
} from './types';

const resourceBase = 'world-cup/overview';

function unwrap<T>(json: ApiResponse<T> | T): T {
  if (json && typeof json === 'object' && 'data' in json) {
    return (json as ApiResponse<T>).data;
  }

  return json as T;
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resourceBase}${path}`, options as any);

  return unwrap<T>(json);
}

export type GetKpiParams = {
  from?: string;
  to?: string;
};

function buildQuery(params?: GetKpiParams) {
  if (!params) return '';
  const search = new URLSearchParams();
  if (params.from) search.append('from', params.from);
  if (params.to) search.append('to', params.to);
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export const worldCupOverviewApi = {
  getKpi(params?: GetKpiParams, signal?: AbortSignal) {
    return request<OverviewKpi>(`/kpi${buildQuery(params)}`, {
      method: 'GET',
      signal,
    } as any);
  },

  getFocusNow(signal?: AbortSignal) {
    return request<OverviewFocusNow>('/focus-now', {
      method: 'GET',
      signal,
    } as any);
  },

  getHealth(signal?: AbortSignal) {
    return request<OverviewHealthRow[]>('/health', {
      method: 'GET',
      signal,
    } as any);
  },

  updateSwitches(payload: UpdateSwitchesPayload) {
    return request<EventSettings>('/switches', {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },

  exportReport() {
    return request<ExportOverviewReportResult>('/export', {
      method: 'POST',
    });
  },
};
